import { ArtistMember } from 'types';
import { NewMember, WizardContext } from 'components/Wizard/types';

export interface MemberDataField {
  name: 'pro_email' | 'address' | 'country' | 'first_name' | 'last_name';
  label: string;
}

/**
 * Returns missing field data as required for a given context
 *
 * If `canEditMember` is `false`, it assumes that the `pro_email` value was
 * likely not returned due to `bio_policy` rules on the backend
 */

export const getMissingArtistMemberFields = (
  member: ArtistMember | NewMember,
  context: WizardContext,
  canEditMember = true
) => {
  const requiredFields: MemberDataField[] =
    context === 'label-release'
      ? [
          { name: 'pro_email', label: 'Email' },
          { name: 'country', label: 'Country' },
          { name: 'first_name', label: 'First Name' },
          { name: 'last_name', label: 'Last Name' }
        ]
      : [{ name: 'pro_email', label: 'Email' }];

  return requiredFields.filter(field => {
    // NOTE: in cases where the user is not allowed to edit the member, the pro_email won't be returned, but
    // in this case, if they are verified they likely have an associated pro_email
    if (!canEditMember && member.verified && field.name === 'pro_email') return false;

    return !member[field.name];
  });
};
